import { Body, Button } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import type { AbgleichZeile } from '../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';
import { teileAuswahl } from '../../hooks/useMitarbeiterabgleich/uebernahme';

export function AuswahlUebernahme({
  zeilen,
  selectedIds,
  onUebernehmen,
  onStandorteZuordnen,
}: {
  zeilen: AbgleichZeile[];
  selectedIds: Set<string>;
  onUebernehmen: (zeilen: AbgleichZeile[]) => void;
  onStandorteZuordnen: (auswahl: {
    mitStandort: AbgleichZeile[];
    ohneStandort: AbgleichZeile[];
  }) => void;
}) {
  const { t } = useTranslation();
  const { mitStandort, ohneStandort } = teileAuswahl(zeilen, selectedIds);
  if (mitStandort.length === 0 && ohneStandort.length === 0) {
    return null;
  }

  if (mitStandort.length > 0 && ohneStandort.length === 0) {
    return (
      <div className="flex items-center justify-between gap-4 rounded-xl border border-neutrals-v2-400 py-2 pr-2 pl-3">
        <Body weight="semibold">
          {t('domain.datev.abgleich.mitarbeiterAusgewählt', {
            count: mitStandort.length,
            gesamt: zeilen.length,
          })}
        </Body>
        <Button
          variant={'secondary-red-on-grey'}
          disabled={mitStandort.length === 0}
          onClick={() => onUebernehmen(mitStandort)}>
          {t('domain.datev.abgleich.auswahlUebernehmen')}
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-4 rounded-xl border border-neutrals-v2-400 py-2 pr-2 pl-3">
      <Body weight="semibold">
        {t('domain.datev.abgleich.ohneStandort', {
          count: ohneStandort.length,
        })}
      </Body>
      <div className="flex gap-2">
        <Button
          variant="outline"
          disabled={mitStandort.length === 0}
          onClick={() => onUebernehmen(mitStandort)}>
          {t('domain.datev.abgleich.auswahlOhneUebernehmen', {
            count: ohneStandort.length,
          })}
        </Button>
        <Button
          variant="secondary-red"
          onClick={() => onStandorteZuordnen({ mitStandort, ohneStandort })}>
          {t('domain.datev.abgleich.standorteZuordnen')}
        </Button>
      </div>
    </div>
  );
}
